import { Component } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  title = 'Posella Client Manager';
  userData: any;

  constructor(private authService: AuthService, public router: Router) {
    
  }
  
  isLoggedIn() {
    return this.authService.isloggedin();
  }

  isViewerMode() {
    return this.router.url.includes('/roster/viewer');
  }

}
